document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('a[href="#ProductInfo-template--main"]').forEach(function(link){
    var info=document.querySelector('[id^="ProductInfo-"]');
    if(info)link.href='#'+info.id;
  });
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    document.querySelectorAll('.rp-video').forEach(function(video){video.pause();video.removeAttribute('autoplay');});
  }
});

if(!customElements.get('rp-quote-carousel')){
  customElements.define('rp-quote-carousel',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      this.track=this.querySelector('.rp-quote-track');
      this.slides=Array.from(this.querySelectorAll('.rp-quote-slide'));
      this.prev=this.querySelector('[data-review-prev]');
      this.next=this.querySelector('[data-review-next]');
      this.count=this.querySelector('.rp-quote-count');
      this.index=0;
      this.prev.addEventListener('click',()=>this.move(-1));
      this.next.addEventListener('click',()=>this.move(1));
      this.track.addEventListener('keydown',event=>{
        if(event.key==='ArrowLeft'||event.key==='ArrowRight'){
          event.preventDefault();this.move(event.key==='ArrowLeft'?-1:1);
        }
      });
      this.track.addEventListener('scroll',()=>{
        cancelAnimationFrame(this.frame);
        this.frame=requestAnimationFrame(()=>this.update());
      },{passive:true});
      this.update();
    }
    move(direction){
      const index=Math.max(0,Math.min(this.slides.length-1,this.index+direction));
      this.track.scrollTo({left:index*this.track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    }
    update(){
      this.index=Math.max(0,Math.min(this.slides.length-1,Math.round(this.track.scrollLeft/Math.max(1,this.track.clientWidth))));
      this.prev.disabled=this.index===0;
      this.next.disabled=this.index===this.slides.length-1;
      const label=(this.index+1)+' / '+this.slides.length;
      if(this.count.textContent!==label)this.count.textContent=label;
    }
  });
}
